import * as React from "react";
import { IoClose } from "react-icons/io5";
import { getCurrentUser, getUser } from "../../services/UserService"

export default function ExceededPopup({ onClose }) {
  const [planName, setPlanName] = React.useState("Free");
  const fetchPlanName = async () => {
    let user = getCurrentUser();
    getUser(user.uid,
        (response) => {
          const userData = response.data;
          if (userData) {
            const userSubscriptionData = userData.subscription || {};
            if(Object.keys(userSubscriptionData).length == 0){
              return false;
            }
            const planDetail = Object.keys(userSubscriptionData)[0];
            const capitalizeWords = (str) => {
              return str
                .split(" ")
                .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
                .join(" ");
            };
            const capitalizedPlanName = capitalizeWords(planDetail);
            setPlanName(capitalizedPlanName);
          }
        },
        (error) => {}
    )
  };
  React.useEffect(() => {
    fetchPlanName();
  }, []);
  return (
    <div className="h-[100vh] w-[100vw] bg-[rgba(0,0,0,0.5)] fixed top-0 left-0 flex flex-col z-40 justify-center items-center">
      <div className="w-fit flex flex-col items-end modalAnimation max-w-[85%] ">
        <div
          onClick={() => {
            onClose();
          }}
          className="bg-white cursor-pointer z-30 mb-[10px] w-fit rounded-full p-[2px]"
        >
          <IoClose />
        </div>
        <div className="md:w-[700px] w-[250px]">
          <div className="rounded-md bg-white border-box relative p-[15px] max-h-[80vh] text-sm sm:text-base  overflow-auto overflow-x-hidden">
            <div className="head-title">
              <h3>{`Your MeetMinutes ${planName} Plan has Ended!`}</h3>
            </div>
            <div className="description">
              <h3>
                Please upgrade to continue experiencing productive, hassel-free
                meetings.
              </h3>
            </div>
            <div className="pricing-cards flex md:flex-row flex-col items-center justify-around mt-3 ">
              <div className="pricing-content ">
                <div className="pricing-card-content flex flex-col items-center rounded-lg border border-gray-100 shadow dark:border-gray-600 bg-white h-[250px] w-[200px] text-center md:mb-0 mb-3">
                  <h4 className="text-lg font-bold mt-2 mb-2">
                    Productivity Pro
                  </h4>
                  <div className="flex justify-center items-baseline my-3">
                    <span className="mr-2 text-2xl font-extrabold">$14</span>
                    <span className="text-gray-500 dark:text-gray-400">
                      /month
                    </span>
                  </div>
                  <div>
                    Upgrade to get 3000 minutes of meetings per month{" "}
                    <a
                      className="text-sky-400"
                      href="https://www.meetminutes.in/pricing"
                      target="_blank"
                    >
                      and much more...
                    </a>{" "}
                  </div>
                  <div>
                    <a
                      href="https://buy.stripe.com/00g3gha7yfR52OIbIR"
                      target="_blank"
                    >
                      <div className="buy-btn mt-3 w-[100px] bg-[#07457F] text-[white] rounded-[10px] flex items-center justify-center">
                        {" "}
                        Buy Now
                      </div>
                    </a>
                  </div>
                </div>
              </div>
              <div className="pricing-content">
                <div className="pricing-card-content flex flex-col items-center rounded-lg border border-gray-100 shadow dark:border-gray-600 bg-white h-[250px] w-[200px] text-center md:mb-0 mb-3">
                  <h4 className="text-lg font-bold mt-2 mb-2">Business Plan</h4>
                  <div className="flex justify-center items-baseline my-3">
                    <span className="mr-2 text-2xl font-extrabold">$24</span>
                    <span className="text-gray-500 dark:text-gray-400">
                      /month
                    </span>
                  </div>
                  <div>
                    Upgrade to get unlimited minutes of meetings per month{" "}
                    <a
                      className="text-sky-400"
                      href="https://www.meetminutes.in/pricing"
                      target="_blank"
                    >
                      and much more...
                    </a>{" "}
                  </div>
                  <div>
                    <a
                      href="https://buy.stripe.com/6oE8ABcfG9sH9d628g"
                      target="_blank"
                    >
                      <div className="buy-btn mt-3 w-[100px] bg-[#07457F] text-[white] rounded-[10px] flex items-center justify-center">
                        {" "}
                        Buy Now
                      </div>
                    </a>
                  </div>
                </div>
              </div>
              <div className="pricing-content">
                <div className="pricing-card-content flex flex-col items-center rounded-lg border border-gray-100 shadow dark:border-gray-600 bg-white h-[250px] w-[200px] text-center md:mb-0 mb-3">
                  <h4 className="text-lg font-bold mt-2 mb-2">
                    Enterprise Plan
                  </h4>
                  <div className="mt-7">
                    Upgrade to an Enterprise Plan for everything in Business
                    Plan{" "}
                    <a
                      className="text-sky-400"
                      href="https://www.meetminutes.in/pricing"
                      target="_blank"
                    >
                      and much more...
                    </a>{" "}
                  </div>
                  <div>
                    <a
                      href="https://www.meetminutes.in/pricing"
                      target="_blank"
                    >
                      <div className="buy-btn mt-3 w-[100px] bg-[#07457F] text-[white] rounded-[10px] flex items-center justify-center">
                        {" "}
                        Contact US
                      </div>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
